import { useHover } from '@uidotdev/usehooks';
import { Edit2, Trash } from 'iconsax-react';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
interface IProps {
  data: any;
  detailData: any;
  setSelectedEl: (value: any) => void;
  i: any;
  index: any;
  handleClickDelete: (data: any, detailData: any, index: any, i: any) => void;
  visible: any;
  setVisible: React.Dispatch<any>;
}
const ActionItems: React.FC<IProps> = ({
  data,
  setSelectedEl,
  i,
  index,
  setVisible,
  detailData,
  visible,
  handleClickDelete,
}) => {
  const [editRef, editHovering] = useHover<HTMLDivElement>();
  const [removeRef, removeHovering] = useHover<HTMLDivElement>();

  return (
    <>
      <IconWrapper
        ref={editRef}
        style={{
          color: editHovering ? theme.colors.blue_500 : theme.colors.dark_200,
        }}
      >
        <Edit2
          size='24'
          onClick={() => {
            setSelectedEl({ data: detailData.localizations[i], i: i });
            setVisible({ ...visible, editLang: true });
          }}
          variant={editHovering ? 'Bold' : 'Linear'}
        />
      </IconWrapper>
      <IconWrapper
        ref={removeRef}
        style={{
          color: removeHovering ? theme.colors.red_500 : theme.colors.dark_200,
        }}
      >
        <Trash
          size='24'
          onClick={() => {
            setSelectedEl(detailData);
            handleClickDelete(data, detailData, index, i);
          }}
          variant={removeHovering ? 'Bold' : 'Linear'}
        />
      </IconWrapper>
    </>
  );
};

export default ActionItems;

const IconWrapper = styled.div`
  cursor: pointer;
`;
